import PropTypes from 'prop-types'
import { useState, createContext } from 'react'

export const SetRouteContext = createContext()
export const GetRouteContext = createContext()

export default function RouterContext({ children }) {
  const [match, setMatch] = useState()
  return (
    <SetRouteContext.Provider value={setMatch}>
      <GetRouteContext.Provider value={match}>
        {children}
      </GetRouteContext.Provider>
    </SetRouteContext.Provider>
  )
}

RouterContext.propTypes = {
  children: PropTypes.node.isRequired,
}
